class CheatController{
    /*@ngInject*/
    constructor(SessionService){
        this.session = SessionService;
    }
    $onInit(){
        let ct = this.session.get('_ct',false);
        if(ct===false || (new Date()).getTime()-ct>3600000) {
            this.session.set('_ct', (new Date()).getTime(), true);
        }
        this.session.remove('user');
    }
}

export default CheatController;


// WEBPACK FOOTER //
// ./public/app/cheat/cheat.controller.js